module.exports = __webpack_public_path__ + "img/pg5-article-text1.af42abd0.png";